export const MODELS_COMPANIES_PER_PAGE = 10;
